import { render, staticRenderFns } from "./ActivitiesTable.vue?vue&type=template&id=3c41b3e6&scoped=true&"
import script from "./ActivitiesTable.vue?vue&type=script&lang=ts&"
export * from "./ActivitiesTable.vue?vue&type=script&lang=ts&"
import style0 from "./ActivitiesTable.vue?vue&type=style&index=0&id=3c41b3e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c41b3e6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
